// ErrorBoundary.jsx
import { useRouteError } from "react-router-dom";

export default function ErrorBoundary() {
  const error = useRouteError(); // 获取路由错误对象

  // 打印完整错误信息到控制台
  console.error("Route Error:", error.message);

  // if (error.message.includes("removeChild")) {
  //   return (
  //     <div className="flex items-center justify-center bg-white">
  //       <Result
  //         status="500"
  //         title="500"
  //         subTitle="不要使用浏览器默认翻译功能"
  //       />
  //     </div>
  //   );
  // }

  return (
    <div className="container text-error py-4">
      <h1>Oops! Error!</h1>

      {/* 显示错误消息 */}
      <p className="py-2">{error.message || error.statusText}</p>

      {/* 显示错误堆栈（开发环境） */}
      <pre className="py-2">{error.stack}</pre>

      {/* 显示状态码（如404） */}
      {error.status && <p className="py-2">HTTP Status Code: {error.status}</p>}
    </div>
  );
}
